<!--
 * @Author:ly
 * @Date: 2020-12-21 15:14:20
 * @LastEditTime: 2021-01-08 16:29:36
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zcjb\src\components\ebs_normlCard.vue
-->
<template>
  <div>
    <h1 class="mt-5 fw-6 text-center">保函服务</h1>
    <div class="e-flex jc-center box container">
      <div
        class="cardBox flex-1 flex-column e-flex"
        v-for="(cardItem, index) in list"
        :key="index"
      >
        <div
          class="cardBox-titlebox flex-column e-flex"
          :style="{
            background: 'url(' + cardItem.img + ') no-repeat center center',
            'background-size': '100% 100%',
          }"
        >
          <span class="cardBox-titlebox--title fs-lg fw-6">{{
            cardItem.Title
          }}</span>
          <span class="cardBox-titlebox--aside mt-3">{{
            cardItem.asideTitle
          }}</span>
        </div>
        <div class="cardBox-mainBox">
          <div
            class="cardBox-mainBox--Item e-flex flex-column text-left"
            v-for="(cardItemTitle, index) in cardItem.detailList"
            :key="index"
          >
            <span class="cardBox-mainBox--title text-grey-6 fw-6 fs-xs mt-1">{{
              cardItemTitle.title
            }}</span>
            <span class="cardBox-mainBox--detail text-grey-5 fs-xs mt-1">{{
              cardItemTitle.explain
            }}</span>
          </div>
          <div class="cardBox-mainBox--Item e-flex flex-column text-left disabled-element"  v-if="cardItem.disable">
            <el-button type="info" 
              >暂未开通</el-button
            >
          </div>
          <div class="cardBox-mainBox--Item e-flex flex-column text-left" v-else>
            <el-button type="primary" @click="router(cardItem)"
              >立即申请</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { data } from './Json'
export default {
  data() {
    return {
      list: data,
    }
  },
  methods: {
    router(item) {
      this.$router.push({ path: item.path })
    },
  },
}
</script>

<style scoped lang="scss">
.box {
  margin: 0 auto;
  color: #ffffff;
  overflow-x: hidden;
  .cardBox {
    border-radius: 8px;
    overflow: hidden;
    width: 285px;
    text-align: center;
    margin: 25px 0;
    &-mainBox {
      padding: 20px;
      background-color: #fff;
      border: 1px solid #dbdbdb;
      border-radius: 0 0 8px 8px;
    }
    &-titlebox {
      height: 130px;
      font-size: 13px;
      img {
        position: relative;
        width: 100%;
      }
      &--aside {
        width: 80%;
        margin: 5px auto;
      }
    }
  }
  .cardBox + .cardBox {
    margin-left: 20px;
  }
  .cardBox-mainBox--Item + .cardBox-mainBox--Item {
    margin-top: 10px;
  }
  .cardBox-titlebox--title {
    padding-top: 23px;
  }
}
.disabled-element {
  cursor: not-allowed;
  pointer-events: none;
  text-decoration: none;
}
</style>
